var map = {
	"./01_server_url.json": "FVkd",
	"./03_error_code.json": "uv3h",
	"./04_rate_limits.json": "XvOK",
	"./04_server_url.json": "w7yn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Q8gQ";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/api/basic \.json$
// module id = Q8gQ
// module chunks = 3